module.exports = "/packs/images/products/subscription-view-0af80c65bdab135a6688e33d4b8295e1.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/products/subscription-view.png
// module id = 1806
// module chunks = 0